import React from "react";
import { StateManagerContext } from "./StateManagerContext";
import { Post, PostDisplayProps } from "./Post";
import { PostConfigData } from "../Shared/Party/PartyConfigData";
import { UIConfigContext } from "./UIConfigContext";


/*export type UserActionDisplayProps = {
    width: number;
    height: number;
    absolute: boolean;
    top?: number,
    left?: number,
    background: string;
    fontBase: number;
    showSignIn(): void;
}*/

export const UserActionDisplay = () : JSX.Element=> {
    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);
    const actions = stateManager.user().actions;
    const postDisplay : PostDisplayProps = {
        postHeight : 400,
        messageHeight : 0,
        userId : stateManager.user().fanbox.id,
    }

    const components = actions.map((action) => {

        return <div style={{ display : 'flex', flexDirection : 'column', backgroundColor : uiConfig.contolBackground, justifyContent : 'right'}}>
            <Post display={postDisplay} config={action.config as PostConfigData}/>
            <div style={{
                                width: "186px",
                                minWidth: "186px",
                                maxWidth: "186px",
                                height: "53px",
                                minHeight: "53px",
                                maxHeight: "53px",
                                borderRadius: "75px",
                                backgroundColor: "#1877F2",
                                lineHeight: "53px",
                                fontSize: "18px",
                                fontWeight: 700,
                                textAlign: "center",
                                color: "white",
                                margin : '20px'
                                
                              }}>Share</div>
        </div>
    })

    if(components.length === 0) {
        components.push(<span style={{fontFamily : 'roboto', fontWeight : 500, fontSize : (2 * uiConfig.fontBase) + 'px'}}>There are currently no actions to display</span>);
    }

    return <div style={{
        width: uiConfig.width + 'px',
        minWidth: uiConfig.width + 'px',
        maxWidth: uiConfig.width + 'px',
        height: (uiConfig.height - uiConfig.titleHeight) + 'px',
        maxHeight: (uiConfig.height - uiConfig.titleHeight) + 'px',
        minHeight: (uiConfig.height - uiConfig.titleHeight) + 'px',
        backgroundColor : uiConfig.contolBackground,
        overflow: 'auto'
    }}>
        <div style={{
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px'
        }}>
            {components}
        </div>
    </div>
}
